import { render, staticRenderFns } from "./veStuAssocMember.vue?vue&type=template&id=71c5f6d3&scoped=true"
import script from "./veStuAssocMember.vue?vue&type=script&lang=js"
export * from "./veStuAssocMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c5f6d3",
  null
  
)

export default component.exports